export default {
  path: '/products',
  name: 'products',
  component: () => import('../components/Layout'),
  redirect: { name: 'ProductList' },
  children: [
    {
      name: 'ProductList',
      path: '',
      component: () => import('../views/product/List')
    },
    {
      name: 'ProductCreate',
      path: 'create',
      component: () => import('../views/product/Create')
    },
    {
      name: 'ProductShow',
      path: ':id',
      component: () => import('../views/product/Show')
    }
  ]
}
